var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Levelbar.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b8486c3e\"}!../../../node_modules/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Levelbar.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./client/components/layout/Levelbar.vue
// module id = 106
// module chunks = 11